const hashSeed = (s) => {
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
};

const mulberry32 = (a) => () => {
  a |= 0;
  a = (a + 0x6d2b79f5) | 0;
  let t = Math.imul(a ^ (a >>> 15), 1 | a);
  t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
};

export const ThreadArt = ({ seed = "threads-unbound", lines = 8, stars = 26, className = "" }) => {
  const rand = mulberry32(hashSeed(String(seed)));
  const paths = [];
  for (let i = 0; i < lines; i++) {
    const y = rand() * 100;
    const y2 = rand() * 100;
    const c1x = 15 + rand() * 35;
    const c1y = y + (rand() - 0.5) * 70;
    const c2x = 55 + rand() * 35;
    const c2y = y2 + (rand() - 0.5) * 70;
    paths.push({
      d: `M -5 ${y.toFixed(1)} C ${c1x.toFixed(1)} ${c1y.toFixed(1)} ${c2x.toFixed(1)} ${c2y.toFixed(1)} 105 ${y2.toFixed(1)}`,
      o: 0.12 + rand() * 0.5,
      w: 0.25 + rand() * 0.65,
    });
  }
  const starPts = [];
  for (let i = 0; i < stars; i++) {
    starPts.push({ x: rand() * 100, y: rand() * 100, r: 0.12 + rand() * 0.3, o: 0.15 + rand() * 0.5 });
  }
  const silver = paths.length ? paths[Math.floor(rand() * paths.length)] : null;
  return (
    <svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid slice" className={className} aria-hidden="true">
      <rect width="100" height="100" fill="#0A0A0B" />
      {starPts.map((s, i) => (
        <circle key={`s${i}`} cx={s.x} cy={s.y} r={s.r} fill="#F5F5F5" opacity={(s.o * 0.5).toFixed(2)} />
      ))}
      {paths.map((p, i) => (
        <path key={i} d={p.d} fill="none" stroke="#D4AF37" strokeWidth={p.w.toFixed(2)} opacity={p.o.toFixed(2)} strokeLinecap="round" />
      ))}
      {silver && <path d={silver.d} fill="none" stroke="#F5F5F5" strokeWidth="0.3" opacity="0.35" strokeLinecap="round" />}
    </svg>
  );
};

export default ThreadArt;
